(() => {
  'use strict';

  const utmFieldIds = {
    utm_source: 'custom#utm_source',
    utm_medium: 'custom#utm_medium',
    utm_campaign: 'custom#utm_campaign'
  };
  const attendeeCountFieldId = 'custom#met_hoeveel_personen_komt_je_bedrijf_in_totaal_inclusief_jezelf';

  const normalizeCampaignUrl = () => {
    const url = new URL(window.location.href);
    const rawEvent = url.searchParams.get('event') || '';
    const embeddedQueryIndex = rawEvent.indexOf('?');

    if (embeddedQueryIndex < 0) return;

    const eventValue = rawEvent.slice(0, embeddedQueryIndex);
    const embeddedParams = new URLSearchParams(rawEvent.slice(embeddedQueryIndex + 1));
    url.searchParams.set('event', eventValue);
    embeddedParams.forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    window.history.replaceState(window.history.state, '', url);
  };

  const getUtmData = () => {
    const params = new URL(window.location.href).searchParams;
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || ''
    };
  };

  const setFormValue = (field, value) => {
    const descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');

    if (descriptor && typeof descriptor.set === 'function') {
      descriptor.set.call(field, value);
    } else {
      field.value = value;
    }

    field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  };

  const hideFormField = (field) => {
    field.tabIndex = -1;
    field.setAttribute('aria-hidden', 'true');

    const container = field.closest('div[class*="_formFieldContainer_"]');
    if (container) {
      container.hidden = true;
      container.setAttribute('aria-hidden', 'true');
    }
  };

  const syncAttributionFields = (shadowRoot) => {
    const utmData = getUtmData();

    Object.entries(utmFieldIds).forEach(([parameter, fieldId]) => {
      const field = shadowRoot.getElementById(fieldId);
      if (!field) return;

      setFormValue(field, utmData[parameter]);
      hideFormField(field);
    });

    /* Every attendee now registers separately. Keep the legacy required field
       at one so existing Shopify Flow and spreadsheet mappings remain valid. */
    const attendeeCountField = shadowRoot.getElementById(attendeeCountFieldId);
    if (attendeeCountField) {
      setFormValue(attendeeCountField, '1');
      hideFormField(attendeeCountField);
    }
  };

  const observedFormEmbeds = new WeakSet();
  let discoveryAttempts = 0;

  const observeAttributionFields = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((embed) => {
      const shadowRoot = embed.shadowRoot;
      if (!shadowRoot || observedFormEmbeds.has(embed)) return;

      observedFormEmbeds.add(embed);
      syncAttributionFields(shadowRoot);

      const observer = new MutationObserver(() => syncAttributionFields(shadowRoot));
      observer.observe(shadowRoot, { childList: true, subtree: true });
      shadowRoot.addEventListener('submit', () => syncAttributionFields(shadowRoot), true);
    });
  };

  const discoverFormEmbeds = () => {
    observeAttributionFields();
    const embeds = Array.from(document.querySelectorAll('shopify-forms-embed'));
    const allObserved = embeds.length > 0 && embeds.every((embed) => observedFormEmbeds.has(embed));

    if (!allObserved && discoveryAttempts < 120) {
      discoveryAttempts += 1;
      window.setTimeout(discoverFormEmbeds, 250);
    }
  };

  normalizeCampaignUrl();

  const formEmbedObserver = new MutationObserver(observeAttributionFields);
  formEmbedObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', discoverFormEmbeds, { once: true });
  } else {
    discoverFormEmbeds();
  }

  document.addEventListener('shopify:section:load', discoverFormEmbeds);
})();
